export const getters = {
    isLoggedIn: state => !!state.accessToken,
    isImpersonating: state => !!state.impersonateToken,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    currentUser: state => state.currentUser
};
